module.exports = __webpack_public_path__ + "img/loginbg.f09d4c06.png";